import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import params from "../../global_parameters";

export const TCText = [
  {
    id: "T&Cs",
    text: (
      <Fragment>
        <h1>Terms and Conditions</h1>
        <p>
          By using the illustrator, you agree you have read and understood the
          Terms & Conditions set out below.
        </p>
        <h2>1. Use of this illustrator</h2>
        <p>
          This illustrator is solely for guidance purposes and provides estimates only. 
          It is not intended to provide you with financial advice. If you require financial 
          advice, you should contact an independent financial adviser. GAD do not accept 
          any liability for individual financial decisions taken based on the information 
          provided in this illustrator.
        </p>
        <p>
          The results shown are an indication of the benefits you may receive;
          they are not guaranteed and you should not enter into financial
          commitments on the basis of the information provided.
        </p>
        <p>
          This modeller does not override the scheme rules or pension legislation. 
          If there is a difference between the modeller and the scheme rules, 
          the rules will apply.
        </p>
        <p>
          This illustrator only applies to the scheme in Scotland.
        </p>
        <h2>2. How your pension and lump sum have been estimated</h2>
        <h3>
          2.1. Detailed results
        </h3>
        <p>
          The results section shows a comparison of pension and lump sum benefits that 
          might be received if you choose to receive legacy or reformed scheme benefits 
          for the period 1 April 2015 to 31 March 2022 (the “remedy period”). Choosing 
          to receive legacy scheme benefits for service in the remedy period may increase 
          member contributions over this period. Member contributions have not been 
          included in the illustrations.
        </p>
        <h3>2.2. Assumptions</h3>
        <p>
          The results pension and lump sum estimates are based on the following
          key assumptions:
        </p>
        <ul>
          <li>Future CPI inflation = 2% pa.</li>
          <li>
            Future Average Weekly Earnings = 3.25% pa.
          </li>
          <li>
            Some allowance is made for actual revaluation rates when illustrating
            Career Average Revalued Earnings (CARE) scheme benefits.
          </li>
          <li>
            Future CARE revaluation rates assumed to be in line with assumed future
            Average Weekly Earnings, at a rate of 3.25%.
          </li>
          <li>
            Deferred revaluation of CARE benefits is applied at the assumed CPI
            rate of 2%. Note: This assumption is used in cases where members 
            can choose to retire before 55 in the legacy scheme, and they are assumed to 
            defer their CARE scheme pension until age 55.
          </li>
          <li>
            Future salary increases = 3.25% pa by default. However, salary increases can be 
            specified by the user (between 0 and 6%).
          </li>
          <li>
            Past salary increases will differ depending on whether you input your 
            current salary and/or your salary as at 1 April 2015.
            <ul style={{margin: "0 0 0 0"}}>
              <li>
                If users specify both 2015 salary and current salary, then your salary is assumed to 
                increase on a straight-line basis from 1 April 2015 to the present day.
              </li>
              <li>
                If only one salary item is provided then your past salary is assumed to 
                increase by 3.25% pa by default from 1 July 2015 onwards, or as specified by 
                the user in the slider in the “Detailed results” section.
              </li>
            </ul>
          </li>
          <li>
            Salary increases do not allow for any future promotional salary increases you may receive.
          </li>
          <li>
            It is assumed that you will retire on normal terms (i.e. you are not retiring in ill-health).
          </li>
          <li>
            The model takes a simple approach to calculating final salary (i.e. last 12 months) and makes
            no allowance for actual final salary definitions in the relevant scheme.
          </li>
          <li>
            A simplified approach has been taken to determine an individual's State Pension Age (SPA). 
          </li>
          <li>
            It is assumed you will remain in your current rank until retirement.
          </li>
        </ul>
        <h3>2.3 Age retirement</h3>
        <p>
          You will be able to vary your retirement age in line with scheme regulations and between ages <b>50 – 60 only</b>.   
        </p>
        <p>
        The modeller allows for retirement from active service only. If you have already deferred or retired, 
        please do not use this modeller as you are out of scope. 
        </p>
        <p>
          If you are already eligible for retirement, 
          the illustrator will offer you an “immediate retirement” option which can be in between integer ages, 
          as well as offering retirement at every integer age up to the maximum retirement age of 60 that the illustrator allows. 
        </p>
        <p>
          If you are not already eligible for retirement, the illustrator will offer you the first integer age 
          at which you will be eligible for retirement. 
        </p>
        <h3>2.4. Adjustments for early payment of pension</h3>
        <p>The amount of pension you may receive depends on when you retire.</p>
        <p>
          If you are a 1992 member, you may be eligible to retire from active service at 55, or earlier at age 50 or over with 
          at least 25 years' service.
        </p>
        <p>
          In the 2006 Special Scheme, the Normal Pension Age is 55. 
        </p>
        <p>
          In the 2006 Scheme, the Normal Pension Age is 60. You can also retire from 55 subject to benefits being actuarially reduced.
        </p>
        <p>
          As age retirements in the illustrator are capped at 60, members who are
          looking for an estimate for retirement over the age of 60 are unable to 
          use this illustrator.
        </p>
        <p>
          Please note:
        </p>
        <p>
          If you are a 1992 Scheme member, you may be entitled to retire before age 55. If you are eligible and choose to retire 
          before age 55 your 2015 Scheme pension will be payable without reduction from SPA. 
          <b> However, the modeller does not display the pension being paid in instalments before and after age 55 
          for CARE and legacy benefits. As such, for the purposes of illustration in this modeller, if you choose 
          to retire from the 1992 Scheme below age 55, 2015 scheme benefits are assumed to be deferred until age 55 
          and benefits are actuarially reduced (relative to deferred pension age SPA).</b>
        </p>
        <p>
          If you choose to retire from the 1992 Scheme at age 55 or later then you will be eligible to retire from the 
          2015 Scheme at the same time with actuarial reduction applied relative to age 60.  
        </p>
        <p>
          If you are a 2006 Scheme member, you can retire from age 55 or later. You will be eligible to retire from the 2015 Scheme at the same time. 
          Where retirement age is earlier than the 2006 Scheme and 2015 Scheme normal retirement age of 60, your benefits in both schemes 
          will be reduced for early payment. 
        </p>
        <p>
          If you are a 2006 Special Scheme member, you can retire from age 55 or later. You will be eligible to retire from the 2015 Scheme at the same time. 
          Where retirement age is below 60, the amount of 2015 Scheme pension shown includes actuarial adjustments for the earlier start of payments 
          than the 2015 Scheme normal retirement age of 60.
        </p>
        <p>
          The actuarial adjustments described above will be reviewed
          periodically, and may increase or decrease. Your benefits at retirement
          will depend on actuarial adjustment factors in effect at that time.
        </p>
        <h3>2.5. Cash lump sum</h3>
        <p>
        At retirement you will be able to choose how much pension to commute for a lump sum (within limits) from each of the legacy and reformed schemes. 
        This illustrator uses the commutation factors currently in effect. Please note that the 1992 commutation factors for Scotland are underpinned 
        by the England commutation factors. As the commutation factors are higher for England currently, these are used for the calculations of the 
        lump sum in the 1992 scheme. However, commutation factors are reviewed periodically and the amount of cash lump sum available at your actual retirement 
        will depend on the commutation factors in effect at that time.
        </p>
        <h3>2.6 Other pension benefits</h3>
        <p>
          The results do not include any money purchase Additional Voluntary Contributions 
          (AVCs) benefits, added years or added pension which you may have purchased, pension 
          debits or other special arrangements within the schemes.
        </p>
        <p>
          The illustrator does not show pension from other sources, for example the 
          state pension or other private arrangements you may have.
        </p>
        <p>
          Your scheme provides survivor benefits payable in the event of your death, 
          which are not shown here. See your scheme guide for details. 
          Your benefit statement may also provide further information.
        </p>
        <p>
          No allowance has been made for guaranteed minimum pension (GMP) and any 
          impact that GMP has on when benefits can be taken.
        </p>
        <h3>2.7 Retained service and gaps in service</h3>
        <p>
          If you have both wholetime and retained service this illustrator must be completed
          separately for each employment, reflecting the specific relevant service and salary
          information. This also applies to expected future service, which you should enter
          as 0% to your retirement date if you are not in active service.
        </p>
        <p>
          For wholetime employment you will need to input a service history from your date
          of joining up until your intended retirement date. You can input estimated figures
          into this section, or alternatively you can contact the SPPA to acquire the actual
          information from your record. If you do not input these service history lines, your
          calculation will assume a working percentage of 100% wholetime equivalent service.
        </p>
        <p>
          For retained employment you will need to input a service history from 1 April 2015
          up until your intended retirement date, as well as your total pensionable service
          at 1 April 2015.  You can input estimated figures into this section, or alternatively
          you can contact the SPPA to acquire the actual information from your record. If you
          do not provide an expected service plan to retirement, the calculation will assume
          a working percentage that continues to retirement in line with the most recent figure
          provided. Other periods not covered by the service history will be assumed to
          reflect 100% wholetime equivalent service.
        </p>
        <p>
          If you have a break in service less than 5 years, you can enter the relevant
          period and set the service percentage to 0%.
        </p>
        <p>
          Please do not use the tool if you have a gap in service of more than 5 years. 
          In this case, the illustrator will likely overestimate your benefits.
        </p>
        <h3>2.8 Transfers in</h3>
        <p>
          If you have a transfer value, you can enter details into the modeller. 
        </p>
        <p>
          For transfers before 1 April 2015:  you can input the service transferred on the 
          transfer date in years and days in the transferred in service input. For 1992 members, 
          this will be included in service calculations to check retirement eligibility 
          and weighted accrual rate. 
        </p>
        <p>
          You should also include any transfers before 1 April 2015 in the total 
          service at 1 April 2015 input. The total service as at 1 April 2015 will be used for the final
          salary benefit calculations. 
        </p>
        <p>
          For transfers after 1 April 2022: you can input your transferred in pension as at the date of transfer value 
          in the transferred in service input. This will be revalued up to retirement by the Average Weekly Earnings 
          rate from scheme year transfer occurred.  
        </p>
        <h3>2.9 Service cap</h3>
        <p>
          Members reaching the service cap (30 years in the 1992 Scheme, 
          45 years in the 2006 Scheme and 30 years in the 2006 Special Scheme) 
          have been assumed to be allowed to join the 2015 Scheme from 1 April 2022. 
          Members are able to opt out of the scheme on reaching 30 years of service 
          (whilst remaining in employment), with entitlement to immediate payment of 
          their pension on subsequent retirement. 
        </p>
        <h2>3. Taxation</h2>
        <p>
          The illustrations do not allow for taxation, aside from the unauthorised 
          payment charge. Your benefits will be subject to the various tax rates and 
          limits in force. You may wish to seek specialist advice if you think you 
          could be affected.
        </p>
        <p>
          In certain circumstances, for some members, it is currently possible to 
          take a maximum commuted lump sum from the 1992 scheme which exceeds that 
          which HMRC allows to be paid tax free. In those circumstances if maximum 
          commutation is taken the member will incur a tax liability. The maximum 
          lump sum figures given in the results are not limited to what can be taken 
          tax free. The results page will indicate where a tax liability arises and 
          show the lump sum figures net of this unauthorised tax charge.
        </p>
        <p>
          In the 2006 Special Scheme you can commute up to one quarter of your pension 
          provided the resultant lump sum would not be greater than the maximum permitted by HMRC. 
          This limit is most likely to be exceeded if the relevant commutation factor is greater than 20. 
          An allowance has been made for this restriction, ensuring that the slider will not permit you to 
          exceed the HMRC limit and as such you may be restricted to being able to commute less than 
          25% of your pension at retirement.
        </p>
      </Fragment>
    ),
  },
];

export const SmallPrintText = [
  {
    id: "SP",
    text: (
      <Fragment>
        <h2>How to use this illustrator</h2>
        <p>
        It will not check your information against pension or other systems,
        so if you enter inaccurate information, the figures you get will be 
        of limited value. No data you enter into this illustrator is stored 
        or processed.
        </p>
        <p>
          By using this illustrator, you agree that you have read
          and understood the Terms & Conditions as set out in the{" "}
          <Link to="/T&Cs">T&Cs tab</Link>.
        </p>
        <p>
          This illustrator is for guidance and illustration only, it is
          not a benefit offer. It will give you a basic illustration of your pension 
          benefits in the 2015 Section and your legacy scheme in two scenarios: 
          choosing the legacy scheme and choosing the reformed scheme. 
          Other sources of income and taxation, except for unauthorised payment
          charges, are not taken into account. If you have these, 
          or other additional options, the figures you get may be less accurate, 
          but still helpful. The outputs of the illustrator are not financial 
          advice - if you’d like to speak to an independent financial adviser 
          you can find one at <a href="https://www.unbiased.co.uk/">unbiased.co.uk</a>.
        </p>
        <p>The assumptions we have used are:</p>
        <table>
          <tbody>
            <tr>
              <td>Future CPI Inflation</td>
              <td>2% per year</td>
            </tr>
            <tr>
              <td>Future Average Weekly Earnings</td>
              <td>3.25% per year</td>
            </tr>
          </tbody>
        </table>
        <p>
          Some allowance is made for actual revaluation rates when illustrating
          Career Average Revalued Earnings (CARE) scheme benefits. 
          Thereafter, future CARE revaluation rates for active 
          periods of service are assumed to be in line with Average Weekly Earnings 
          at 3.25% per year. For deferred periods of service, the rates are 
          assumed to be in line with CPI at 2% per year.
        </p>
        <p>
          Users can set their own future salary increases between 0% and 6%. If
          users do not enter a salary as at 1 April 2015 on the "Your Details" page, 
          salaries between 2015 and the current date are estimated using this assumption.
        </p>
        <p>
        The figures output by the illustrator are projected benefits and will not
         be the same as those in your Annual Benefit Statement.
        </p>
        <p>
        The projected benefits can be shown in real or nominal terms. If benefits
        are shown in <b>real</b> terms, this means the values are adjusted for inflation
        and represent what the pension would be worth today, so you can compare
        it with your current earnings and the amount you think you'll need in 
        retirement. Projected benefits in <b>nominal</b> terms show the value in monetary
        amounts at the point of payment.
        </p>
        <p>
          The switch between real and nominal figures will be based on the assumed 
          future inflation of 2% p.a.
        </p>
        <p>
          If you have both wholetime and retained service this illustrator must be completed
          separately for each employment, reflecting the specific relevant service and salary
          information. This also applies to expected future service, which you should enter
          as 0% to your retirement date if you are not in active service.
        </p>
        <p>
          For wholetime employment you will need to input a service history from your date
          of joining up until your intended retirement date. You can input estimated figures
          into this section, or alternatively you can contact the SPPA to acquire the actual
          information from your record. If you do not input these service history lines, your
          calculation will assume a working percentage of 100% wholetime equivalent service.
        </p>
        <p>
          For retained employment you will need to input a service history from 1 April 2015
          up until your intended retirement date, as well as your total pensionable service
          at 1 April 2015.  You can input estimated figures into this section, or alternatively
          you can contact the SPPA to acquire the actual information from your record. If you
          do not provide an expected service plan to retirement, the calculation will assume
          a working percentage that continues to retirement in line with the most recent figure
          provided. Other periods not covered by the service history will be assumed to
          reflect 100% wholetime equivalent service.
        </p>
      </Fragment>
    ),
  },
];

export const IntroText = [
  {
    id: "IT",
    text: (
      <Fragment>
        <h2>Welcome to the Remedy Benefits Illustrator</h2>
        <p>
          This illustrator is for guidance purposes only and the outputs provided 
          are an estimate only. It is not intended to provide you with financial 
          advice. If you require financial advice, you should contact an 
          independent financial adviser. 
        </p>
        <p>
          The Remedy gives you a choice, to be made at the point when you take
          your benefits. That choice is between your legacy scheme and the 
          reformed scheme for the Remedy period (1 April 2015 to 31
          March 2022). Both schemes offer highly valuable benefits.
        </p>
        <p>
          The illustrator is designed to provide members who are affected by the
          Remedy with an overview of how different choices may impact their
          benefits at retirement. It allows you to make an approximate
          comparison based on your inputs and certain assumptions about what
          happens in the future. It does not allow for all circumstances.
        </p>
      </Fragment>
    ),
  },
];
